import HTTPClient from '@elab/core/utils/HTTPClient';
import { formFieldsConstants } from '@elab/core/utils/constants';
import cartApi from '@elab/core/store/cart/api';
import { metadataAdapter } from '@elab/core/utils/dynaForms';

async function loadMetadataLegalAge(uri, containsOtcProducts) {
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Failed loading metadata ${uri} (${response.status})`);
    }

    const metadata = metadataAdapter(await response.json());

    const steps = metadata.steps.reduce((acc, step) => {
        const fields = step.fields.map(field => {
            if (field.name !== 'dateOfBirth') return field;

            // Field should be hidden from customer and it should has default value
            if (!containsOtcProducts) {
                field.type = formFieldsConstants.hidden;
            } else {
                field.defaultValue = '';
            }

            return field;
        });
        return [...acc, { ...step, fields }];
    }, []);
    return { ...metadata, steps };
}

const setBillingAddress = async (userId, cartId, addressDto) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/addresses/billing`;
    const response = await HTTPClient().postJson(uri, addressDto);

    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
};

export default {
    loadMetadataLegalAge,
    setBillingAddress,
};
